module.exports = __webpack_public_path__ + "img/error.19ee6b7e.svg";